import { all, fork } from 'redux-saga/effects'

// Importar sagas dos módulos (serão adicionadas conforme implementação)
import { authSaga } from './modules/auth/saga'
import { cartSaga } from './modules/cart/saga'
import { catalogSaga } from './modules/catalog/saga'
import { checkoutSaga } from './modules/checkout/saga'
import { ordersSaga } from './modules/orders/saga'
import { adminSaga } from './modules/admin/saga'
import { uiSaga } from './modules/ui/saga'

/**
 * Root saga que combina todas as sagas da aplicação
 */
export function* rootSaga() {
  yield all([
    fork(authSaga),
    fork(cartSaga),
    fork(catalogSaga),
    fork(checkoutSaga),
    fork(ordersSaga),
    fork(adminSaga),
    fork(uiSaga),
  ])
}

